import React, { useEffect, useRef } from 'react';
import { Box, TextField } from '@mui/material';
import { Button, Spinner } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import { connect } from 'react-redux';
import { useForm } from 'react-final-form';

const NotesField = ({ currentUser, input, meta }) => {
	const translate = useTranslate();
	const form = useForm();
	const previousSubmitSucceeded = useRef(false);
	const submittingRef = useRef(false);
	const [isSaving, setIsSaving] = React.useState(false);
	const [disabled, setDisabled] = React.useState(false);

	// Clear field after successful form submission
	useEffect(() => {
		if (meta?.submitSucceeded && !previousSubmitSucceeded.current) {
			// Form was just successfully submitted
			setTimeout(() => {
				if (input?.onChange) {
					input.onChange('');
				}
				// Reset form to avoid dirty state that triggers unsaved changes modal
				form.reset();
				submittingRef.current = false;
				setIsSaving(false);
				setDisabled(false);
			}, 1500);
		}
		previousSubmitSucceeded.current = meta?.submitSucceeded || false;
	}, [meta?.submitSucceeded, input, form]);

	// Handle submit errors to reset loading state
	useEffect(() => {
		if (meta?.submitError || meta?.submitFailed) {
			submittingRef.current = false;
			setIsSaving(false);
			setDisabled(false);
		}
	}, [meta?.submitError, meta?.submitFailed]);

	const handleSendClick = () => {
		if (submittingRef.current) return;
		if (!input?.value?.trim()) return;
		submittingRef.current = true;
		setIsSaving(true);
		setDisabled(true);
		// Trigger form submission
		form.submit();
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			if (disabled || submittingRef.current) return;
			handleSendClick();
		}
	};

	return (
		<Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end', mb: 3 }}>
			<TextField
				fullWidth
				multiline
				minRows={1}
				maxRows={6}
				placeholder={translate('Write a note')}
				value={input?.value || ''}
				onChange={(e) => input?.onChange(e.target.value)}
				onKeyDown={handleKeyDown}
				variant="outlined"
				size="small"
			/>
			<Button
				style={{ height: '40px', minWidth: '80px' }}
				onClick={handleSendClick}
				disabled={!input?.value?.trim() || disabled || isSaving}
			>
				{isSaving ? <Spinner size="small" /> : translate('Save')}
			</Button>
		</Box>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.user,
});

export default connect(mapStateToProps)(NotesField);
